/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';
import { UserSportLevelResponse } from './userSportLevelResponse';
import { UserSportTypeLevel } from './userSportTypeLevel';
import { UserEntity } from './userEntity';


export interface UserResponse { 
    id: string;
    avatarUrl: string;
    timezone: string;
    firstName: string;
    lastName: string;
    privacy?: UserResponse.PrivacyEnum;
    user: UserEntity;
    city: string;
    country: string;
    dateOfBirth: string;
    description: string;
    followers: Array<string>;
    followings: Array<string>;
    location: GeoLocationEntity;
    pushToken: string;
    sex: string;
    userId: string;
    work: string;
    sportLevels: Array<UserSportLevelResponse>;
    likeds: Array<string>;
    unlikeds: Array<string>;
    userMatchs: Array<string>;
    zipCode: string;
    historicSportLevels: Array<UserSportTypeLevel>;
    isMyLastNameAnonymised: boolean;
    createdAt: string;
}
export namespace UserResponse {
    export type PrivacyEnum = 'public' | 'private' | 'hidden';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        Hidden: 'hidden' as PrivacyEnum
    };
}


